import { INode } from 'shared/types/tree'
import { getSubjectId } from 'shared/utils/tree'
import { useSubjectsById } from './subjects.atoms'
import { ISubject } from 'shared/types/subjects'

export function useSubjectForTree(tree: INode): ISubject | undefined {
  const subjectId = getSubjectId(tree)
  const subjects = useSubjectsById() ?? {}
  if (subjectId && subjectId in subjects) {
    return subjects[subjectId]
  }
}
